import { Component, inject, ViewEncapsulation } from '@angular/core';
import { StringUtils }                          from '../../../utils/string.utils';
import { MAT_DIALOG_DATA, MatDialogRef }        from '@angular/material/dialog';
import { DialogComponent }                      from '../dialog.component';
import { DialogTitleComponent }                 from '../title/title.component';
import { DialogContentComponent }               from '../content/content.component';
import { DialogActionsComponent }               from '../actions/actions.component';
import { ButtonComponent }                      from '../../buttons/button.component';

@Component({
  selector: 'pin-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [DialogComponent, DialogTitleComponent, DialogContentComponent, DialogActionsComponent, ButtonComponent]
})
export class ConfirmDialogComponent {
  title: string = StringUtils.EMPTY;
  subheading: string = StringUtils.EMPTY;
  confirmLabel: string;
  private dialogRef = inject<MatDialogRef<ConfirmDialogComponent>>(MatDialogRef);

  constructor() {
    const data = inject(MAT_DIALOG_DATA);

    this.title = data.title;
    this.subheading = data.subheading;
    this.confirmLabel = data.confirmLabel;
  }

  cancel() {
    this.dialogRef.close('cancel');
  }

  confirm() {
    this.dialogRef.close('confirm');
  }

}
